import { TextareaHTMLAttributes } from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";

import { FormField } from "@/components/form/FormField";

export function TextareaField({
  id,
  label,
  error,
  rows = 4,
  register,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement> & {
  id: string;
  label: string;
  error: FieldError["message"] | null;
  register: UseFormRegisterReturn | null;
}) {
  return (
    <FormField id={id} label={label} error={error} register={register}>
      <textarea
        id={id}
        rows={rows}
        className="w-full rounded-md border px-3 py-2"
        {...props}
      />
    </FormField>
  );
}
